import DailyFerryList from '@/controllers/daily_ferry/daily-ferry-list.js';

export default {
  extends: DailyFerryList,
  methods: {
    handlePaginate(page) {
      if (this.searchBtnStatus) {
        this.search(page);
      } else {
        this.getDailyFerry(page);
      }
    }
  }
};
